import { getCurrentInstance } from "vue";

import type { PopupManager } from "@/shared/plugins/PopupManager";
import type { BasePopupProps, PopupConfig } from "@/shared/plugins/interface";

export function usePopupManager() {
    // getCurrentInstance()를 사용하기 위해서는 "setup 컨텍스트" 내에서 이 함수를 호출해야 함
    const instance = getCurrentInstance();
    if (!instance) {
        throw new Error("No current instance found. usePopupManager must be called within setup.");
    }

    const popupManager: PopupManager = instance.appContext.config.globalProperties.$popupManager;

    /**
     * 팝업 열기
     * @param component 팝업 연결 컴포넌트
     * @param params 팝업 연결 컴포넌트에 전달할 파라미터
     * @returns 팝업 키
     */
    const openPopup = <T extends BasePopupProps>(config: PopupConfig<T>): string => {
        return popupManager.openPopup(config);
    };

    /**
     * 팝업 닫기
     * @param closeKey 팝업 키
     */
    const closePopup = (closeKey: string) => {
        popupManager.closePopup(closeKey);
    };

    /**
     * @description
     * 팝업 전체 닫기
     */
    const clearPopup = () => {
        popupManager.clearPopup();
    };

    /**
     * @description
     * 팝업 조회
     */
    const hasPopupList = () => {
        const popupList = popupManager.getPopupList();
        return popupList.length > 0;
    };

    return {
        openPopup,
        closePopup,
        clearPopup,
        hasPopupList,
    };
}
